import React from 'react';
import DOMPurify from 'dompurify';
import { highlightKeyWords } from '../../Utils/KeywordHighlightUtil';

class TextViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.createCleanMarkup = this.createCleanMarkup.bind(this);
  }

  componentDidMount() {
    const { highlights, className, mustHavesKeywords } = this.props;
    if (className) {
      const mergedKeywordList = [...highlights, ...mustHavesKeywords];
      setTimeout(() => {
        highlightKeyWords(['div.text-resume-viewer'], mergedKeywordList, 'mark');
        highlightKeyWords(['div.text-resume-viewer'], mustHavesKeywords, 'mustHaveMark');
      }, 0);
    }
  }

  createCleanMarkup() {
    const { text } = this.props;
    const clean = DOMPurify.sanitize(text);
    return { __html: clean };
  }

  render() {
    const { className } = this.props;
    /* eslint-disable react/no-danger */
    return (
      <div className={`${className || ''} text-resume-viewer`}>
        <pre style={{ fontFamily: 'inherit' }} dangerouslySetInnerHTML={this.createCleanMarkup()} />
      </div>
    );
  }
}

export default TextViewer;
